import { render, staticRenderFns } from "./orderWayBill.vue?vue&type=template&id=49c83086&scoped=true"
import script from "./orderWayBill.vue?vue&type=script&lang=js"
export * from "./orderWayBill.vue?vue&type=script&lang=js"
import style0 from "./orderWayBill.vue?vue&type=style&index=0&id=49c83086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c83086",
  null
  
)

export default component.exports